import React from "react";
import { BADGE_TEXT } from "./meetingFormat";
import type { MeetingBadge } from "./meetingFormat";
import css from "./Meetings.module.css";

/** Live (with a pulsing dot) / Starting soon / Ended / Scheduled. */
const StatusChip: React.FC<{ badge: MeetingBadge }> = ({ badge }) => (
  <span className={`${css.chip} ${css["chip_" + badge]}`}>
    {badge === "live" && <span className={css.dot} aria-hidden="true" />}
    {BADGE_TEXT[badge]}
  </span>
);

export default StatusChip;
